var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "workflow-settings" } },
    [
      _c(
        "SupsisButton",
        {
          on: {
            click: function ($event) {
              return _vm.$feature.beforeCreateTaskWorkflow(_vm.createWorkflow)
            },
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.$t("settings.create")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "supsis-table" },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.columns,
              "data-source": _vm.filterWorkflows,
              pagination: false,
            },
            scopedSlots: _vm._u([
              {
                key: "id",
                fn: function (record) {
                  return _c("div", { staticStyle: { margin: "0" } }, [
                    _vm._v(_vm._s(record.slice(0, 9))),
                  ])
                },
              },
              {
                key: "name",
                fn: function (record) {
                  return _c("div", { staticStyle: { margin: "0" } }, [
                    _vm._v(_vm._s(record)),
                  ])
                },
              },
              {
                key: "default",
                fn: function (record, data) {
                  return _c(
                    "div",
                    { staticStyle: { margin: "0" } },
                    [
                      _c("a-checkbox", {
                        staticClass: "supsis-checkbox",
                        on: {
                          change: function ($event) {
                            return _vm.changeDefaultWorkflow(record, data)
                          },
                        },
                        model: {
                          value: data.default,
                          callback: function ($$v) {
                            _vm.$set(data, "default", $$v)
                          },
                          expression: "data.default",
                        },
                      }),
                    ],
                    1
                  )
                },
              },
              {
                key: "edit",
                fn: function (record, data) {
                  return _c("div", { staticStyle: { margin: "0" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "material-icons",
                        staticStyle: { color: "#18bdb5", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.editWorkflow(data)
                          },
                        },
                      },
                      [_vm._v("\n                    edit\n                ")]
                    ),
                  ])
                },
              },
              {
                key: "delete",
                fn: function (record, data) {
                  return _c("div", { staticStyle: { margin: "0" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "material-icons",
                        staticStyle: { color: "#ec4b1d", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteWorkflowFunc(data)
                          },
                        },
                      },
                      [_vm._v("\n                    delete\n                ")]
                    ),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "total-workflow-container" }, [
        _vm._v(
          _vm._s(_vm.$t("report.total")) + ": " + _vm._s(_vm.workflows.length)
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }